import { render } from "./Registrar.vue?vue&type=template&id=e4b1976a&scoped=true"
import script from "./Registrar.vue?vue&type=script&lang=js"
export * from "./Registrar.vue?vue&type=script&lang=js"

import "./Registrar.vue?vue&type=style&index=0&id=e4b1976a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b1976a"]])

export default __exports__